var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "128px",
    height: "128px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1280 1280",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 640,
    cy: 640,
    r: 640
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "crcl_1",
    className: "fil0 str0",
    cx: 320,
    cy: 320,
    r: 200,
    fill: "#9DBF39"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "crcl1_1_mv",
    begin: "0;crcl1_1_mv.end+0.3s",
    attributeType: "XML",
    attributeName: "cx",
    values: "320;400;320",
    dur: "0.7s"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "crcl1_2_mv",
    begin: "crcl1_1_mv.begin",
    attributeType: "XML",
    attributeName: "cy",
    values: "320;400;320",
    dur: "0.7s"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "crcl_2",
    className: "fil1 str0",
    cx: 960,
    cy: 320,
    r: 200,
    fill: "#429FE0"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "crcl2_1_mv",
    begin: "crcl1_1_mv.begin",
    attributeType: "XML",
    attributeName: "cx",
    values: "960;880;960",
    dur: "0.7s"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "crcl2_2_mv",
    begin: "crcl1_1_mv.begin",
    attributeType: "XML",
    attributeName: "cy",
    values: "320;400;320",
    dur: "0.7s"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "crcl_3",
    className: "fil2 str0",
    cx: 960,
    cy: 960,
    r: 200,
    fill: "#FFBF05"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "crcl3_1_mv",
    begin: "crcl1_1_mv.begin",
    attributeType: "XML",
    attributeName: "cx",
    values: "960;880;960",
    dur: "0.7s"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "crcl3_2_mv",
    begin: "crcl1_1_mv.begin",
    attributeType: "XML",
    attributeName: "cy",
    values: "960;880;960",
    dur: "0.7s"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "crcl_4",
    className: "fil3 str0",
    cx: 320,
    cy: 960,
    r: 200,
    fill: "#CF3022"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "crcl4_1_mv",
    begin: "crcl1_1_mv.begin",
    attributeType: "XML",
    attributeName: "cx",
    values: "320;400;320",
    dur: "0.7s"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "crcl4_2_mv",
    begin: "crcl1_1_mv.begin",
    attributeType: "XML",
    attributeName: "cy",
    values: "960;880;960",
    dur: "0.7s"
  }))), /*#__PURE__*/React.createElement("animateTransform", {
    id: "rtt_1",
    begin: "0;rtt_4.end+0.3s",
    attributeName: "transform",
    type: "rotate",
    from: "0 640 640",
    to: "90 640 640",
    dur: "0.7s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "rtt_2",
    begin: "rtt_1.end+0.3s",
    attributeName: "transform",
    type: "rotate",
    from: "90 640 640",
    to: "180 640 640",
    dur: "0.7s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "rtt_3",
    begin: "rtt_2.end+0.3s",
    attributeName: "transform",
    type: "rotate",
    from: "180 640 640",
    to: "270 640 640",
    dur: "0.7s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    id: "rtt_4",
    begin: "rtt_3.end+0.3s",
    attributeName: "transform",
    type: "rotate",
    from: "270 640 640",
    to: "360 640 640",
    dur: "0.7s",
    fill: "freeze"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingProgress);
export default __webpack_public_path__ + "static/media/loading-progress.6230087d.svg";
export { ForwardRef as ReactComponent };